import axios from 'ts-axios-new'
import { queryPath } from 'utils/index'

const rootPath = queryPath()
const localhost = rootPath.substring(0, rootPath.lastIndexOf('/'))

console.info(rootPath)
console.info(localhost)

const urlMap = {
  development: `${localhost}/weixin-manager`,
  production: `${localhost}/weixin-manager`
}

// const urlMap = {
//   development: 'http://localhost:8080',
//   production: 'http://wxboxtest.skyworthbox.com/weixin-manager/'
// }

const baseUrl = urlMap[process.env.NODE_ENV]
const ERR_OK = 0

export function get (url) {
  return function (params = {}) {
    return axios.get(baseUrl + url, {
      params
    }).then((res) => {
      const { code, data } = res.data
      if (code === ERR_OK) {
        return data
      } else {
        return null
      }
    }).catch((e) => {
      console.info(e)
    })
  }
}

export function post (url) {
  return function (params = {}) {
    return axios.post(baseUrl + url, params.query).then(res => {
      return res
    }).catch((e) => {
      console.info(e)
    })
  }
}
